import { Grid } from '@material-ui/core'
import {
  Wrapper,
  Body,
  SubmitButton,
  CancelButton,
  SaveButton,
  Header,
  ButtonContainer,
  Footer,
  FormContainer
} from './styles'
import fields from '1.newComponents/fields'
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setValues, clearValues, selectFormSlice } from './formSlice'
import {
  setValidation,
  selectValidationSlice,
  clearValidations
} from './validationSlice'
import { VALIDATIONS } from '0.componentConfigs/1.validations'
import { REQUEST_TYPE, SUPPORTING_DOCUMENTS } from 'types'
import { Redirect } from 'react-router-dom'
import Backdrop from '../backdrop'

function Form ({ config }) {
  const dispatch = useDispatch()
  const formSlice = useSelector(selectFormSlice)
  const validationSlice = useSelector(selectValidationSlice)
  const { configData, handleSubmit, handleNext } = config
  useEffect(() => {
    return () => {
      dispatch(clearValues())
      dispatch(clearValidations())
    }
  }, [])

  return formSlice.crfId ? (
    <Redirect to={`/checkRequest/${formSlice.crfId}`} />
  ) : (
    <>
      {formSlice.progress > 0 && <Backdrop progress={formSlice.progress} />}
      <Wrapper>
        <FormContainer>
          <Header>
            <ButtonContainer>
              <SaveButton onClick={configData.handleSave}>Save</SaveButton>
            </ButtonContainer>
            <ButtonContainer>
              <CancelButton onClick={configData.handleCancel}>
                Cancel
              </CancelButton>
            </ButtonContainer>
          </Header>
          <Body>
            <Grid container spacing={1}>
              {configData.map(data => {
                // Change handler for all fields exept supporting documents since its data cannot be stored in the redux
                if (data.fieldName !== SUPPORTING_DOCUMENTS) {
                  data.onChange = e => {
                    dispatch(
                      setValues({
                        fieldName: data.fieldName,
                        value: e.target.value
                      })
                    )
                    if (data.placeholder !== 'Optional') {
                      const result = VALIDATIONS[data.fieldName](
                        e,
                        data.options
                      )
                      dispatch(
                        setValidation({
                          fieldName: data.fieldName,
                          error: result[0],
                          message: result[1]
                        })
                      )
                    }
                  }
                  data.onBlur = e => {
                    if (data.placeholder !== 'Optional') {
                      const result = VALIDATIONS[data.fieldName](
                        e,
                        data.options
                      )
                      dispatch(
                        setValidation({
                          fieldName: data.fieldName,
                          error: result[0],
                          message: result[1]
                        })
                      )
                    }
                  }
                  data.value = formSlice[data.fieldName]
                }

                data.error = validationSlice[data.fieldName][0]
                data.errorMessage = validationSlice[data.fieldName][1]

                // error handler

                return (
                  <Grid key={data.label} item {...data.grid}>
                    {fields[data.component](data)}
                  </Grid>
                )
              })}
            </Grid>
          </Body>
          <Footer>
            {handleNext !== null && (
              <ButtonContainer>
                <SubmitButton onClick={handleSubmit}>Next</SubmitButton>
              </ButtonContainer>
            )}
            <ButtonContainer>
              <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
            </ButtonContainer>
          </Footer>
        </FormContainer>
      </Wrapper>
    </>
  )
}

export default Form
